module.exports = __webpack_public_path__ + "static/media/logo-inverted.0653f680.svg";